import React from 'react'
import { useTranslation } from 'next-i18next'
import { CustomCard } from 'src/components'
import { useAppSelector } from 'src/app/hooks'
import { currentOffsetStep } from 'src/features'
import { UploadExcelFileStep, SelectOffsetKeysStep, PreviewPurchasesStep, MakePurchaseStep } from './OffsetByExcelSteps'

const OffsetByExcelContent = () => {
  const { t } = useTranslation()

  const currentStep: number = useAppSelector(currentOffsetStep)

  const steps = [
    UploadExcelFileStep,
    SelectOffsetKeysStep,
    PreviewPurchasesStep,
    MakePurchaseStep
  ]
  const CurrentStep = steps[currentStep] || UploadExcelFileStep

  return (
    <CustomCard cardTitle={t('developers.OffSet.Title')}>
      <CurrentStep />
    </CustomCard>
  )
}

export default OffsetByExcelContent
